import { gql } from '@grandvisionhq/graphql';

const GET_CONTACT_LENS_BY_PRESCRIPTION = gql`
  query getContactLensByPrescription(
    $masterVariantSku: String!
    $prescription: ContactLensOpticalParametersInput!
  ) {
    getContactLensByPrescription(masterVariantSku: $masterVariantSku, prescription: $prescription) {
      __typename
      ... on GetContactLensByPrescriptionSuccessResponse {
        result {
          productMasterKey
          name
          slug
          variants(masterVariantSkus: [$masterVariantSku]) {
            sku
            gan
            isAllowBackOrder
            inventory {
              stockIndicator
              totalQuantity
            }
          }
        }
      }
      ... on GetContactLensByPrescriptionFailureResponse {
        failures {
          __typename
          ... on Failure {
            message
          }
          ... on GeneralProductFailure {
            reason
          }
        }
      }
    }
  }
`;

export { GET_CONTACT_LENS_BY_PRESCRIPTION };
//# sourceMappingURL=get-contact-lens-by-prescription.js.map
